export default function Footer() {
  return (
    <footer className="footer-shell mt-16">
      <div className="section-shell flex flex-col gap-3 px-6 py-8 text-center md:flex-row md:items-center md:justify-between md:text-left">
        <p className="font-semibold text-stone-800">© 2026 SignAI</p>
        <p className="text-stone-600">
          Real-time sign language translation with a cleaner research-first
          interface.
        </p>
      </div>
    </footer>
  );
}
